const IS_PRESENT = (value: any): boolean =>
	value !== null && value !== undefined && String(value).trim() !== '';

// Email OR phone. Requiring both dropped carriers that only have an email.
export const HAS_EXPORT_CONTACT_INFO = (contact: any): boolean => {
	if (!contact) {
		return false;
	}
	const hasEmail = IS_PRESENT(contact.emailAddress) || IS_PRESENT(contact.email);
	const hasPhone =
		IS_PRESENT(contact.phone) || IS_PRESENT(contact.mobile) || IS_PRESENT(contact.phoneNumber);
	return hasEmail || hasPhone;
};

// Same order as getOfferContactMapId(): primaryCarrierContactMapId -> contactDTOs[0] -> contactDTO.
const GET_PROJECT_CONTACT = (projectCarrierMap: any, carrier: any): any => {
	if (!projectCarrierMap) {
		return null;
	}
	const contactDTOs = projectCarrierMap.contactDTOs || [];

	if (projectCarrierMap.primaryCarrierContactMapId) {
		// contact.id is the carrierContactMapId on both sources
		const matched =
			contactDTOs.find((contact) => contact?.id === projectCarrierMap.primaryCarrierContactMapId) ||
			(carrier?.contacts || []).find(
				(contact) => contact?.id === projectCarrierMap.primaryCarrierContactMapId
			);
		if (matched) {
			return matched;
		}
	}

	return contactDTOs[0] || projectCarrierMap.contactDTO || null;
};

// Project contact if one is set, else the carrier's primary, else any contact we can reach.
export const GET_PROJECT_EXPORT_CONTACT = (projectCarrierMap: any, carrier: any): any => {
	// A project contact missing one field still wins; one we cannot reach at all does not.
	const projectContact = GET_PROJECT_CONTACT(projectCarrierMap, carrier);
	if (HAS_EXPORT_CONTACT_INFO(projectContact)) {
		return projectContact;
	}

	const contacts = carrier?.contacts || [];
	const primaryContact = contacts.find(
		(contact) => contact?.primaryContact === true && HAS_EXPORT_CONTACT_INFO(contact)
	);
	if (primaryContact) {
		return primaryContact;
	}

	return contacts.find((contact) => HAS_EXPORT_CONTACT_INFO(contact)) || null;
};
